// extracted by mini-css-extract-plugin
export default {"Main":"main_Main__msdKi"};